import { DATES, DATES_ID } from 'services/constants/dates-constants';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
	TTableStructureButton,
} from 'ui/EasTable/types';
import { TFiscalReportListItem } from 'redux/reducers/fiscalReports/types';
import {
	EReportMtaStatus,
	EReportStatus,
	EReportType,
	EReportInvoicePaymentStatus,
	EPaymentHandlingMode,
	PAYMENT_HANDLING_MODE,
} from 'redux/reducers/fiscalReports/constants';
import { EIconButtons } from '../../ui/EasTable/EasTableRow/EasTableValue/constants';

export const tableStructure: TTableStructure<keyof TFiscalReportListItem>[] = [
	{
		name: 'Global ID',
		selector: 'global_id' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		key: true,
	},
	{
		name: 'ID',
		selector: 'id' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'EM ID',
		selector: 'em_id' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Client',
		selector: 'client' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.EM,
		value: (item: TFiscalReportListItem) => {
			return { id: item.em_id, name: item.client };
		},

		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'EM Identifier',
		selector: 'em_identifier' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},

	{
		name: 'Report Due Date',
		selector: 'timestamp' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		filter: [
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.FISCAL_REPORT_RANGE, DATES.FISCAL_REPORT_RANGE],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		defaultFilterValue: DATES_ID.FISCAL_REPORT_RANGE,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Duration',
		selector: 'duration' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.DATE_RANGE,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Report Period',
		selector: 'report_period' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Report Period Name',
		selector: 'report_period_name' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		filter: [
			['January', 'January'],
			['February', 'February'],
			['March', 'March'],
			['April', 'April'],
			['May', 'May'],
			['June', 'June'],
			['July', 'July'],
			['August', 'August'],
			['September', 'September'],
			['October', 'October'],
			['November', 'November'],
			['December', 'December'],
			['Q1', 'Quarter 1'],
			['Q2', 'Quarter 2'],
			['Q3', 'Quarter 3'],
			['Q4', 'Quarter 4'],
		],
		colors: [
			['January', 'primary.light'],
			['February', 'primary.light'],
			['March', 'primary.light'],
			['April', 'primary.light'],
			['May', 'primary.light'],
			['June', 'primary.light'],
			['July', 'primary.light'],
			['August', 'primary.light'],
			['September', 'primary.light'],
			['October', 'primary.light'],
			['November', 'primary.light'],
			['December', 'primary.light'],
			['Q1', 'info.light'],
			['Q2', 'info.light'],
			['Q3', 'info.light'],
			['Q4', 'info.light'],
		],
	},
	{
		name: 'Year',
		selector: 'year' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Report Period',
		selector: 'report_period_and_year' as keyof TFiscalReportListItem,
		value: (item: TFiscalReportListItem) => `${item.report_period_name} ${item.year}`,
		show: true,
		showInFoolData: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Is Notified',
		selector: 'is_notified' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		filter: [
			['true', 'Yes'],
			['false', 'No'],
		],
		colors: [
			['true', 'success.light'],
			['false', 'warning.light'],
		],
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Report Type',
		selector: 'report_type' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		filter: [
			[EReportType.IOSS, 'IOSS'],
			[EReportType.UNION, 'Union'],
			[EReportType.NON_UNION, 'Non-Union'],
			[EReportType.NON_EU_IOSS, 'Non-EU Import'],
		],
		// colors: [
		// 	[EReportType.IOSS, 'success.light'],
		// 	[EReportType.UNION, 'warning.light'],
		// 	[EReportType.NON_UNION, 'info.light'],
		// 	[EReportType.NON_EU_IOSS, 'primary.light'],
		// ],
		colSpan: 1,
	},
	{
		name: 'Reported At',
		selector: 'report_date' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Payment Filing Timestamp',
		selector: 'payment_filing_timestamp' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Reg. Country',
		selector: 'scheme_registered_country' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.COUNTRY,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	// {
	// 	name: 'Reg. Country Code',
	// 	selector: 'scheme_registered_country_code' as keyof TFiscalReportListItem,
	// 	show: false,
	// 	showInFoolData: true,
	// 	sortable: true,
	// 	filterable: true,
	// 	type: ETableStructureType.COUNTRY_CODE,
	// 	align: ETableStructureAlign.CENTER,
	// 	colSpan: 1,
	// },
	{
		name: 'Scheme Intermediary ID',
		selector: 'scheme_intermediary_id' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Scheme  ID',
		selector: 'scheme_id' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: false,
		separateFilter: true,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},

	{
		name: 'Reg. Country',
		selector: 'scheme_registered_country_code' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.COUNTRY_CODE_EU,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Intermediary Info ID',
		selector: 'intermediary_info_id' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Access Information',
		selector: 'access_information' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Instructions File',
		selector: 'instructions_file' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Instructions File Name',
		selector: 'instructions_file_name' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'VAT Amount to be Reported',
		selector: 'total_vat_due' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'VAT Amount Reported',
		selector: 'reported_vat_amount' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Payment Mode',
		selector: 'payment_handling_mode' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		filter: [
			[EPaymentHandlingMode.DIRECT, PAYMENT_HANDLING_MODE[EPaymentHandlingMode.DIRECT]],
			[EPaymentHandlingMode.INDIRECT, PAYMENT_HANDLING_MODE[EPaymentHandlingMode.INDIRECT]],
		],
		defaultFilterValue: EPaymentHandlingMode.INDIRECT,
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},

	{
		name: 'MTA Report Status',
		selector: 'mta_report_status' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		filter: [
			[EReportMtaStatus.SENT, 'Sent'],
			[EReportMtaStatus.SUBMITTED, 'Submitted'],
			[EReportMtaStatus.PENDING, 'Pending'],
			[EReportMtaStatus.CANCELED, 'Canceled'],
			[EReportMtaStatus.QUEUED, 'Queued'],
			[EReportMtaStatus.ERROR, 'ERROR'],
			[EReportMtaStatus.UNFINISHED_WITH_WARNINGS, 'Unfinished with warnings'],
			[EReportMtaStatus.UNFINISHED, 'Unfinished'],
		],
		colors: [
			[EReportMtaStatus.SENT, 'success.light'],
			[EReportMtaStatus.SUBMITTED, 'success.light'],
			[EReportMtaStatus.PENDING, 'warning.light'],
			[EReportMtaStatus.CANCELED, 'error.light'],
			[EReportMtaStatus.QUEUED, 'info.light'],
			[EReportMtaStatus.ERROR, 'error.light'], // TODO: сделать ярче
			[EReportMtaStatus.UNFINISHED_WITH_WARNINGS, 'warning.light'],
			[EReportMtaStatus.UNFINISHED, 'warning.light'],
		],
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Errors',
		selector: 'errors' as keyof TFiscalReportListItem,
		show: false,
		showInFoolData: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Comment',
		selector: 'comment' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},

	{
		name: 'Invoice Payment Status',
		selector: 'invoice_payment_status_new' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		filter: [
			[EReportInvoicePaymentStatus.PAID, 'Paid'],
			[EReportInvoicePaymentStatus.PENDING, 'Pending'],
			[EReportInvoicePaymentStatus.PARTIALLY_PAID, 'Partially Paid'],
			[EReportInvoicePaymentStatus.OVERDUE, 'Overdue'],
			[EReportInvoicePaymentStatus.NO_INVOICE_FOUND, 'No invoice found'],
		],
		colors: [
			[EReportInvoicePaymentStatus.PAID, 'success.light'],
			// ['pending', 'warning.light'],
			[EReportInvoicePaymentStatus.PARTIALLY_PAID, 'warning.light'],
			[EReportInvoicePaymentStatus.OVERDUE, 'error.light'],
			// ['no_invoice_found', 'error.light'],
		],
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Report Status',
		selector: 'status' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: true,
		filterable: true,
		filter: [
			[EReportStatus.PENDING, 'Pending'],
			[EReportStatus.SUBMITTED, 'Submitted'],
		],
		colors: [
			// ['pending', 'warning.light'],
			// ['submitted', 'success.light'],
		],
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},

	{
		name: 'Actions',
		noName: true,
		selector: 'actions' as keyof TFiscalReportListItem,
		show: true,
		showInFoolData: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		buttons: [
			{ name: 'pdf', icon: EIconButtons.PICTURE_AS_PDF },
			{ name: 'csv', icon: EIconButtons.TABLE_CHART },
			{ name: 'xlsx', icon: EIconButtons.TABLE_CHART },
			{ name: 'edit', icon: EIconButtons.EDIT },
			// { name: 'comment', icon: EIconButtons.COMMENT },
		],
		buttonFilter: (item: TFiscalReportListItem) => {
			const baseButtons: TTableStructureButton[] = [];

			if (
				item.mta_report_status !== EReportMtaStatus.SENT &&
				item.mta_report_status !== EReportMtaStatus.SUBMITTED &&
				item.mta_report_status !== EReportMtaStatus.QUEUED &&
				item.scheme_registered_country_code === 'EE' &&
				(item.report_type === EReportType.IOSS ||
					item.report_type === EReportType.UNION ||
					item.report_type === EReportType.NON_UNION)
			) {
				baseButtons.push({
					name: 'Zero',
					label: 'Submit the report with zero',
					// icon: EIconButtons.SEND,
					color: 'info.dark',
				});
			}

			if (item.report_type === EReportType.IOSS && item.scheme_registered_country_code === 'EE')
				baseButtons.push({ name: 'xml' });
			else baseButtons.push({ name: 'csv' });

			if (item.report_type !== EReportType.NON_EU_IOSS) baseButtons.push({ name: 'xlsx' });

			if (item.payment_handling_mode === EPaymentHandlingMode.INDIRECT) {
				baseButtons.push({
					name: 'Mark as Filed',
					label: 'Mark as filed or edit filing information',
					icon: EIconButtons.CHECK_CIRCLE,
				});
			}
			baseButtons.push({
				name: 'comment',
				label: 'Add or edit comments for the report',
				icon: EIconButtons.COMMENT,
			});
			if (
				item.mta_report_status === EReportMtaStatus.PENDING &&
				item.report_type === EReportType.IOSS &&
				item.scheme_registered_country_code === 'EE'
			) {
				baseButtons.push({
					name: 'cancel',
					label: 'Cancel the report submission',
					icon: EIconButtons.CANCEL_SCHEDULE_SEND,
				});
			}
			if (
				item.mta_report_status !== EReportMtaStatus.SENT &&
				item.mta_report_status !== EReportMtaStatus.SUBMITTED &&
				item.mta_report_status !== EReportMtaStatus.QUEUED &&
				item.scheme_registered_country_code === 'EE' &&
				(item.report_type === EReportType.IOSS ||
					item.report_type === EReportType.UNION ||
					item.report_type === EReportType.NON_UNION)
			) {
				baseButtons.push({
					name: 'submit',
					label: 'Submit the report',
					icon: EIconButtons.SEND,
				});
			}

			return baseButtons;
		},
	},
];
